import React from 'react';

export type DynomiteModule = typeof import('@dynamon-as/dynomite');

export default React.createContext<DynomiteModule | undefined>(undefined);

export const loadDynomite = async (): Promise<DynomiteModule | undefined> => {
    try {
        const dynomite = await import('@dynamon-as/dynomite');
        await dynomite.$init;
        return dynomite;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return undefined;
    }
};
